import { Box, Heading } from "@chakra-ui/react";
import AdvantageCardList from "@/components/advantageCard";
import PageLayout from "@/layouts/pageLayout";
import { LBGhoverEffect } from "styles/hoverPresets";
import OfferingBgImage from "public/openStack/background.png";
import { MIGRATION_CONSTANTS } from "./constants";

const MigrationComponent = () => {
  return (
    <Box bgImage={`url(${OfferingBgImage.src})`} bgSize="cover">
      <PageLayout>
        <Heading as="h2" fontWeight={"400"} textAlign={"center"} fontSize={"40px"}>
          {MIGRATION_CONSTANTS.TITLE}
        </Heading>
        <AdvantageCardList
          columns={{ base: 1, sm: 2, md: 4 }}
          items={MIGRATION_CONSTANTS.ITEMS}
          bgColor="white"
          alignDirection="start"
          hoverEffect
          hover={LBGhoverEffect}
        />
      </PageLayout>
    </Box>
  );
};

export default MigrationComponent;
